// src/services/pms/index.ts
import { apaleoAdapter } from './apaleo-adapter';
import type { PMSAdapter } from './types';

/**
 * PMS abstraction layer — single entry point for all PMS calls.
 *
 * The active adapter is selected by the `VITE_PMS_ADAPTER` env var
 * (default: `'apaleo'`). All 62 consuming files import from here, so
 * swapping to the custom PMS requires only:
 *   1. Create `src/services/pms/custom-pms-adapter.ts`
 *   2. Set `VITE_PMS_ADAPTER=custom` in `.env.local`
 *   3. No other files need to change.
 */
const ADAPTER: string = import.meta.env.VITE_PMS_ADAPTER || 'apaleo';

let pms: PMSAdapter;
if (ADAPTER === 'apaleo') {
  pms = apaleoAdapter;
} else {
  throw new Error(`Unknown PMS adapter: ${ADAPTER}`);
}

// Re-export ALLOWED_PROPERTIES and setAllowedProperties as live bindings.
// These come from apaleo.js (via apaleo-adapter.ts) — `ALLOWED_PROPERTIES`
// is a mutable `let`, so named re-exports (not destructuring) preserve the
// live binding so consumers see updates after setAllowedProperties() runs.
// React components should prefer `useAllowedProperties()` (src/hooks) so they
// re-render when the list is populated; subscribe/snapshot back that hook.
export {
  ALLOWED_PROPERTIES,
  setAllowedProperties,
  subscribeAllowedProperties,
  getAllowedPropertiesSnapshot,
} from './apaleo-adapter';

export default pms;
